
<div class="w-full h-[57px] bg-[#334155] border rounded-md flex justify-start items-center gap-4 pl-4 font-rubik">
  <img src="@/images/get-quote-modal/current-location.svg" alt="Fetch location">
  <p class="user-location-text">With this information, we can provide the ideal solution for you.</p>
</div>
